import { useEffect, useState } from "react";

import { useSelector } from "common/utilities/react-redux";
import { setThemeColorMeta } from "common/utilities/setThemeColorMeta";
import { getSelectedTheme } from "domains/theme/selectors";

export const useTheme = () => {
  const selectedTheme = useSelector(getSelectedTheme);
  const [prefersDark, setPrefersDark] = useState<boolean>(matchPrefersDark().matches);

  useEffect(() => {
    const prefersDarkMediaQueryList = matchPrefersDark();
    const listener = ({ matches }: MediaQueryListEvent) => setPrefersDark(matches);
    prefersDarkMediaQueryList.addEventListener("change", listener);
    return () => prefersDarkMediaQueryList.removeEventListener("change", listener);
  }, []);

  const theme = selectedTheme ?? (prefersDark ? "dark" : "light");
  setThemeColorMeta(theme);
  return theme;
};

const matchPrefersDark = () => window.matchMedia("(prefers-color-scheme: dark)");
